import React, { useState, useEffect, useCallback } from "react";
import { Table } from "semantic-ui-react";
import { ActionButtons, Container, HeaderWrapper } from "./styles";
import { RiDeleteBinLine } from "react-icons/ri";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 } from "../../../../services/apis";

export const VacancyList = () => {
  const [vacancies, setVacancies] = useState([]);

  useEffect(() => {
    producaov2
      .get("/voitto-vacancies")
      .then((response) => setVacancies(response.data.items));
  }, []);

  const removeVacancy = useCallback(
    (id) => {
      swal({
        title: "Remoção de Vaga",
        text: "Você tem certeza que quer remover essa vaga?",
        buttons: {
          confirm: "Sim",
          cancel: "Não",
        },
      }).then((res) => {
        if (res) {
          producaov2.delete(`voitto-vacancies/${id}`).then((res) => {
            console.log("Removido");
            const newVacancies = [...vacancies].filter(
              (vacancy) => vacancy.id !== id
            );
            setVacancies(newVacancies);
          });
        }
      });
    },
    [vacancies]
  );

  return (
    <div
      style={{
        padding: "0 0 0px 250px",
      }}
    >
      <AdminMenu />
      <Container>
        <HeaderWrapper>
          <h1>Vagas em aberto</h1>
          <a href="/admin/rh/vacancies/create">Adicionar nova vaga</a>
        </HeaderWrapper>
        <Table>
          <Table.Header>
            <Table.HeaderCell>ID</Table.HeaderCell>
            <Table.HeaderCell>Vaga</Table.HeaderCell>
            <Table.HeaderCell>Modelo</Table.HeaderCell>
            <Table.HeaderCell>Tipo</Table.HeaderCell>
            <Table.HeaderCell>Link</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Header>

          <Table.Body>
            {vacancies.length ? (
              vacancies.map((vacancy) => (
                <Table.Row key={vacancy.id}>
                  <Table.Cell>{vacancy.id}</Table.Cell>
                  <Table.Cell title={vacancy.role_position}>
                    {vacancy.role_position}
                  </Table.Cell>
                  <Table.Cell>{vacancy.model}</Table.Cell>
                  <Table.Cell>{vacancy.type}</Table.Cell>
                  <Table.Cell title={vacancy.vacancy_link}>
                    {vacancy.vacancy_link}
                  </Table.Cell>
                  <Table.Cell>
                    <ActionButtons>
                      <a
                        href={`/admin/rh/vacancies/edit/${vacancy.id}`}
                        target="_blank"
                      >
                        <FaRegEdit size={16} color="var(--color-primary)" />
                      </a>
                      <button onClick={() => removeVacancy(vacancy.id)}>
                        <FaTrash size={16} color="var(--color-primary)" />
                      </button>
                    </ActionButtons>
                  </Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell colSpan={6}>Nenhuma vaga encontrada</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Container>
    </div>
  );
};
